export default "__VITE_ASSET__DQejHH2S__"